function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div>
          <div className="footer-brand">
            Grow<span className="logo-highlight">Grind</span>
          </div>
          <p className="footer-text">
            Grow in Grace, Grind in peace
          </p>
          <p className="footer-copyright">
            © {new Date().getFullYear()} GrowGrind. Tous droits réservés.
          </p>
        </div>
        
        <div className="social-icons">
          <a href="https://www.facebook.com/share/1BNtkmZbrF/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="social-link">
            <img src="/facebook.png" alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/growgrind?igsh=eDEyNGhnbmk3eTdt" target="_blank" rel="noreferrer" className="social-link">
            <img src="/instagram.png" alt="Instagram" />
          </a>
          <a href="https://www.tiktok.com/@epok.sa.yo?_r=1&_t=ZP-91zzKFM6oxz" target="_blank" rel="noreferrer" className="social-link">
            <img src="/tic-tac.png" alt="TikTok" />
          </a>
          <a href="https://www.youtube.com/@growgrind" target="_blank" rel="noreferrer" className="social-link">
            <img src="/youtube.png" alt="YouTube" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
